<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
        <div class="col orange">
          <h3>
            <i class="fas fa-hands"></i> Insured/Uninsured Report
          </h3>
        </div>
        <div class="text-right">
          <label class="custom-toggle">
            <input v-model="insuredBuyOrSell" type="checkbox" @change="setInsuredReportData" id="insuredCheck" />
            <span class="custom-toggle-slider rounded-circle"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Chart -->
      <div class="chart">
        <canvas id="insuredChart"></canvas>
      </div>
      <a href @click="showPopup" class="view-more">View More<i class="fa fa-arrow-circle-right" ></i></a>

      <!-- <a href class="text-right view-more" @click="showPopup">View More</a> -->
    </div>
    <!-- Modal -->
    <div
      class="modal fade bd-example-modal-xl"
      id="chartViewMoreInsured"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Insured / Uninsured Report</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="subHead">
              <div class="col-lg-9 col-5 tradeDate">
                <!-- <h4>Trade Date Range</h4>
                <form>
                  <div class="form-group">
                    <label for="exampleFormControlInput1">From</label>
                    <input
                      type="date"
                      v-model="popupFromDate"
                      @change="getPopupInsuredReportData"
                      class="form-control"
                      placeholder="MM/DD/YYYY"
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleFormControlInput1">To</label>
                    <input
                      type="date"
                      v-model="popupToDate"
                      @change="getPopupInsuredReportData"
                      class="form-control"
                      placeholder="MM/DD/YYYY"
                    />
                  </div>
                </form> -->
              </div>
              <div class="text-right">
                <span class="lbl">Buy</span>
                <label class="custom-toggle">
                  <input type="checkbox" v-model="popupInsuredBuyOrSell" @change="setPopupInsuredReportData">
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
                <span class="lbl">Sell</span>
              </div>
              <!-- <div class="text-right">
                <label class="custom-toggle">
                  <input
                    v-model="popupInsuredBuyOrSell"
                    type="checkbox"
                    @change="setPopupInsuredReportData"
                  />
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
              </div> -->
            </div>
            <div class="graph">
              <canvas id="popupInsuredChart"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import this.$http from "this.$http";
import config from "@/config";
//import $ from "jquery";
import chartConstants from "@/chartConstants";
//import Chart from "chart.js";

export default {
  props: ["fromdate", "todate"],
  watch: {
    $props: {
      handler: function() {
        this.getInsuredReportData();
      },
      deep: true
    }
  },
  data() {
    return {
      accessToken: null,
      insuredBuyOrSell: false,
      insuredChartOptions: chartConstants.pieChartDefault,
      insuredChartData: {},
      popupInsuredChartOptions: chartConstants.pieChartDefaultPopup,
      popupInsuredChartData: {},
      popupInsuredBuyOrSell: false,
      myChart : null,
      myChartPoup :null
      // popupFromDate: this.fromdate,
      // popupToDate: this.todate
    };
  },
  methods: {
    getInsuredReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/insured?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=True",
          auth
        )
        .then(result => {
          this.insuredChartData = result.data.data;
          this.setInsuredReportData();
        });
    },
    setInsuredReportData() {
      this.insuredChartOptions.data.labels = this.insuredBuyOrSell
        ? this.insuredChartData.sellsLabels
        : this.insuredChartData.buysLabels;
      this.insuredChartOptions.data.datasets[0].data = this.insuredBuyOrSell
        ? this.insuredChartData.sells
        : this.insuredChartData.buys;

      if(this.myChart){
        this.myChart.destroy();
      }   
      const ctx = document.getElementById("insuredChart");
      this.myChart = new window.Chart(ctx, {
        type: this.insuredChartOptions.type,
        data: this.insuredChartOptions.data,
        //== plugins: [ChartDataLabels],
         options: this.insuredChartOptions.options,
      });
    },
    getPopupInsuredReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/insured?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.popupInsuredChartData = result.data.data;
          this.setPopupInsuredReportData();
        });
    },
    setPopupInsuredReportData() {
      this.popupInsuredChartOptions.data.labels = this.popupInsuredBuyOrSell
        ? this.popupInsuredChartData.sellsLabels
        : this.popupInsuredChartData.buysLabels;
      this.popupInsuredChartOptions.data.datasets[0].data = this
        .popupInsuredBuyOrSell
        ? this.popupInsuredChartData.sells
        : this.popupInsuredChartData.buys;
      if(this.myChartPoup){
        this.myChartPoup.destroy();
      }     
      const ctx = document.getElementById("popupInsuredChart");
      this.myChartPoup = new window.Chart(ctx, {
        type: this.popupInsuredChartOptions.type,
        data: this.popupInsuredChartOptions.data,
        options: this.popupInsuredChartOptions.options
      });
    },
    showPopup(event) {
      event.preventDefault();
      this.getPopupInsuredReportData();
      window.$("#chartViewMoreInsured").modal("show");
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getInsuredReportData();
      }
    });
   
  }
};
</script>